import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Cursos from './views/Cursos.vue'
import Galeria from './views/Galeria.vue'
import Aprovados from './views/Aprovados.vue'
import Contato from './views/Contato.vue'
import Tecnologias from './views/Tecnologias.vue'
import Noticias from './views/Noticias.vue'
import Material from './views/Material.vue'
import CursosModulares from './views/CursosModulares.vue'
import Simulados from './views/Simulados.vue'
import Espaco from './views/Espaco.vue'
import Projetos from './views/Projetos.vue'
import TravelMap from './views/TravelMap.vue'

Vue.use(Router)
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/projetos',
      name: 'projetos',
      component: Projetos
    },
    {
      path: '/espaco',
      name: 'espaco',
      component: Espaco
    },
    {
      path: '/noticias/:id',
      name: 'noticias',
      component: Noticias
    },
    {
      path: '/travel',
      name: 'travel',
      component: TravelMap
    },
    {
      path: '/modulares',
      name: 'modulares',
      component: CursosModulares
    },
    {
      path: '/simulados',
      name: 'simulados',
      component: Simulados
    },
    {
      path: '/material',
      name: 'material',
      component: Material
    },
    {
      path: '/cursos',
      name: 'cursos',
      component: Cursos
    },
    {
      path: '/galeria',
      name: 'galeria',
      component: Galeria
    },
    {
      path: '/aprovados',
      name: 'aprovados',
      component: Aprovados
    },
    {
      path: '/contato',
      name: 'contato',
      component: Contato
    },
    {
      path: '/tecnologias',
      name: 'tecnologias',
      component: Tecnologias
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }

  ]
})
